/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Deployservicev3Destination } from '../models/Deployservicev3Destination';
import { HttpFile } from '../http/http';

export class V1OrderLineDeploymentDestinationSet {
    'orderLineId'?: string;
    'orgId'?: string;
    'requestId'?: string;
    'timestamp'?: Date;
    'userId'?: string;
    'deploymentDestination'?: Deployservicev3Destination;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "deploymentDestination",
            "baseName": "deployment_destination",
            "type": "Deployservicev3Destination",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineDeploymentDestinationSet.attributeTypeMap;
    }

    public constructor() {
    }
}

